import type { GridColumnVisibilityModel, GridColDef } from '@mui/x-data-grid-premium'
import { getStorage, setStorage } from 'lib/utils'


const COLUMN_VISIBILITY_KEY = 'leads.columnVisibilityModel'
const COLUMN_ORDER_KEY = 'leads.columnOrder'
const PAGE_SIZE_KEY = 'leads.pageSize'
const DEFAULT_PAGE_SIZE = 25

export function loadColumnVisibilityModel(): GridColumnVisibilityModel {
  return getStorage(COLUMN_VISIBILITY_KEY) ?? {}
}

export function saveColumnVisibilityModel(model: GridColumnVisibilityModel) {
  setStorage(COLUMN_VISIBILITY_KEY, model)
}

export function loadColumnOrder(): string[] {
  return getStorage(COLUMN_ORDER_KEY) ?? []
}

export function saveColumnOrder(columnOrder: string[]) {
  setStorage(COLUMN_ORDER_KEY, columnOrder)
}

export function applyColumnOrder<T extends GridColDef>(
  columns: T[],
  columnOrder: string[],
  columnVisibilityModel?: GridColumnVisibilityModel
): T[] {
  const columnsByField = new Map(columns.map((column) => [column.field, column]))

  const orderedColumns = [
    ...columnOrder
      .map((field) => columnsByField.get(field))
      .filter((column): column is T => !!column),
    ...columns.filter((column) => !columnOrder.includes(column.field)),
  ]

  if (!columnVisibilityModel) return orderedColumns

  const visibleColumns: T[] = []
  const hiddenColumns: T[] = []

  orderedColumns.forEach((column) => {
    if (columnVisibilityModel[column.field] === false) {
      hiddenColumns.push(column)
    } else {
      visibleColumns.push(column)
    }
  })

  return [
    ...visibleColumns,
    ...hiddenColumns.sort((a, b) =>
      (a.headerName ?? a.field).localeCompare(b.headerName ?? b.field)
    ),
  ]
}

export function loadPageSize(): number {
  return getStorage(PAGE_SIZE_KEY) ?? DEFAULT_PAGE_SIZE
}

export function savePageSize(pageSize: number) {
  setStorage(PAGE_SIZE_KEY, pageSize)
}
